import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'imgResize', pure: true, standalone: true })
export class ImageResizePipe implements PipeTransform {
  public transform(imgUrl: string, width = 338, height = 284): string {
    return imgUrl.indexOf('budgetinternational') === -1 ? `${imgUrl}?func=crop&w=${width}&h=${height}&sharp=1` : imgUrl;
  }
}
